import { Checkbox, FormControlLabel, type CheckboxProps } from '@mui/material';
import { Checkbox as CheckboxUI } from '../../Checkbox';
import { Text } from '../../Text';
import { type HealthxchangeThemeColours } from '../../../theme/defaultTheme';
import { type TextVariant } from '../../../theme/typography';

export interface CheckboxInputProps extends CheckboxProps {
  id: string;
  checked?: boolean;
  readOnly?: boolean;
  onChange?: () => void;
  label: string;
  title?: string;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  disabled?: boolean;
  value: boolean;
  labelColor?: keyof typeof HealthxchangeThemeColours;
  labelVariant?: keyof typeof TextVariant;
  surface?: 'default' | 'inverse';
}

export const CheckboxInput = ({
  id,
  onChange,
  label,
  title,
  value,
  disabled = false,
  checked = false,
  readOnly = false,
  labelPlacement = 'end',
  sx,
  labelColor,
  labelVariant = 'p2',
  surface = 'default',
}: CheckboxInputProps) => {
  const resolvedLabelColor =
    labelColor ?? (surface === 'inverse' ? 'white' : disabled ? 'darkGray' : 'black');
  const resolvedSx = [
    {
      maxHeight: '1.875rem',
    },
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];

  return (
    <FormControlLabel
      sx={resolvedSx}
      label={
        <Text variant={labelVariant} color={resolvedLabelColor}>
          {label}
        </Text>
      }
      labelPlacement={labelPlacement}
      title={title}
      control={
        <Checkbox
          id={id}
          checked={checked}
          onChange={onChange}
          icon={
            <CheckboxUI
              size="small"
              type={disabled && !readOnly ? 'disabled' : 'unchecked'}
              surface={surface}
            />
          }
          checkedIcon={
            <CheckboxUI
              size="small"
              type={disabled && !readOnly ? 'disabled' : 'checked'}
              surface={surface}
            />
          }
          value={value}
          disabled={disabled}
          tabIndex={0}
          disableRipple={true}
          disableFocusRipple={true}
        />
      }
    />
  );
};
